export default __webpack_public_path__ + "static/media/badge-message.f1ad118b.svg";